module.exports = __webpack_public_path__ + "img/vertical_6_6_3016.4586bfaa.png";